document.documentElement.classList.remove('no-js');
document.addEventListener('click', function (event) {
  const trigger = event.target.closest('[data-menu-toggle]');
  if (trigger) {
    const menu = document.getElementById(trigger.getAttribute('aria-controls'));
    const open = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!open));
    if (menu) menu.hidden = open;
  }
  const accordion = event.target.closest('[data-accordion]');
  if (accordion) {
    const panel = document.getElementById(accordion.getAttribute('aria-controls'));
    const open = accordion.getAttribute('aria-expanded') === 'true';
    accordion.setAttribute('aria-expanded', String(!open));
    if (panel) panel.hidden = open;
  }
});
document.addEventListener('change', function (event) {
  if (!event.target.matches('[data-variant-select]')) return;
  const option = event.target.options[event.target.selectedIndex];
  const form = event.target.closest('form');
  if (form) form.querySelector('[name="id"]').value = option.value;
  const price = document.querySelector('[data-product-price]');
  if (price && option.dataset.price) price.textContent = option.dataset.price;
});
